import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useEditor,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import { lazy, useEffect, useRef, useState } from "react";
import apiFetch from "@wordpress/api-fetch";
import Button from "../button/block";
import { useTranslation } from "react-i18next";
import style from "./block.module.scss";
import { stripTags, traducButton } from "../shared/tools";
import he from "he";

const Inspector = lazy(() =>
  import("../shared/inspector/singleProductInspector")
);

export const ProductInsert = ({
  product,
  productId,
  variantProps,
  ...props
}) => {
  const { t } = useTranslation();
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();

  const [displayedProduct, setDisplayedProduct] = useState(product);
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  // Get product or variant information
  useEffect(() => {
    if (!isEditing) return;

    let fetchParams = {};
    if (productId !== -1) {
      fetchParams = { id_product: productId };
    } else if (variantProps && variantProps.id) {
      fetchParams = { id_product: variantProps.id };
    } else {
      return;
    }

    apiFetch({
      path:
        "/sbm/v1/get_product_by_id?" +
        new URLSearchParams(fetchParams).toString(),
    }).then((res) => {
      if (isMounted.current) {
        if (variantProps && variantProps.isVariant) {
          if (variantProps.name) {
            res.title = variantProps.name;
          }
          if (variantProps.size) {
            res.link += "?size=" + variantProps.size.replace(/\D/g, "");
          }
          if (variantProps.image) {
            res.image = variantProps.image;
          }
          if (variantProps.description) {
            res.description = variantProps.description;
          }
        }
        setDisplayedProduct(res);
      }
    });
  }, [isEditing, productId, variantProps]);

  return (
    <BlockWrapper.Div className={style.block}>
      {!displayedProduct ? (
        <div className={style.skeleton}></div>
      ) : (
        <>
          {displayedProduct.link && (
            <div className={style.product}>
              <div className={style.imageContainer}>
                {displayedProduct.image?.url && (
                  /* eslint-disable-next-line */
                  <img
                    src={displayedProduct.image.url}
                    alt={displayedProduct.image?.alt}
                    className={style.iconProduct}
                    loading="lazy"
                  />
                )}
              </div>
              <div className={style.content}>
                <div className={style.info}>
                  {displayedProduct.brand?.name && (
                    <div>{he.decode(displayedProduct.brand.name)}</div>
                  )}

                  {displayedProduct.title && (
                    <div className={style.title}>
                      {he.decode(displayedProduct.title)}
                    </div>
                  )}
                  {displayedProduct.description && (
                    <p className={style.description}>
                      {he.decode(stripTags(displayedProduct.description))}
                    </p>
                  )}
                  <Button
                    text={traducButton(t, "Buy now")}
                    color={style.darkGreen}
                    colorHover={style.darkerGreen}
                    link={!isEditing ? displayedProduct.link : undefined}
                    className={style.btn}
                  />
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </BlockWrapper.Div>
  );
};

export default defineBlock({
  Block: ProductInsert,
  setup: {
    title: "Product Insert (One)",
  },
  smartProps: {
    productId: smartProps.number.withDefault(-1),
    variantProps: smartProps.object.withDefault({}),
    brandId: smartProps.number.withDefault(-1),
  },
});
